<template>
  <div class="privacy-page">
    <div class="page-inner">
      <h1>{{ $t("privacy.title") }}</h1>

      <section class="policy-section">
        <h2>{{ $t("privacy.statementTitle") }}</h2>
        <div
          class="policy-content"
          v-html="formatText($t('privacy.statementContent'))"
        ></div>
      </section>

      <section class="policy-section">
        <h2>{{ $t("privacy.cookieTitle") }}</h2>
        <div
          class="policy-content"
          v-html="formatText($t('privacy.cookieContent'))"
        ></div>
      </section>

      <section class="policy-section">
        <h2>{{ $t("privacy.sessionTitle") }}</h2>
        <div
          class="policy-content"
          v-html="formatText($t('privacy.sessionContent'))"
        ></div>
      </section>

      <section class="policy-section">
        <h2>{{ $t("privacy.pageTagTitle") }}</h2>
        <div
          class="policy-content"
          v-html="formatText($t('privacy.pageTagContent'))"
        ></div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPage",
  methods: {
    formatText(text) {
      return text
        .split(/\n\n+/)
        .map((para) => `<p>${para.replace(/\n/g, "<br>")}</p>`)
        .join("");
    },
  },
};
</script>

<style lang="scss" scoped>
.privacy-page {
  flex: 1;
  padding: 40px 0;
}

.page-inner {
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 24px;

  h1 {
    font-size: 30px;
    color: $primary-orange;
    margin-bottom: 32px;
    font-weight: 700;
  }
}

.policy-section {
  margin-bottom: 28px;

  h2 {
    font-size: 18px;
    color: $text-dark;
    margin-bottom: 12px;
    font-weight: 700;
  }
}

.policy-content {
  ::v-deep p {
    font-size: 16px;
    line-height: 1.8;
    color: $text-dark;
    margin: 0 0 12px;
    letter-spacing: 1px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ::v-deep .text-link {
    color: $primary-orange;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.lang-en .privacy-page {
  h1 {
    letter-spacing: 0px;
  }

  .policy-section h2 {
    letter-spacing: 0px;
  }

  .policy-content ::v-deep p {
    letter-spacing: 0px;
    line-height: 1.5;
  }
}
</style>
